import { memo } from 'react';
import { QualityColorEnum } from 'enums/qualityColor.enum';

import { Container } from './styles';

type QualityProps = {
  quality: QualityColorEnum;
  radius?: string;
};

function Quality({ quality, radius }: QualityProps) {
  return (
    <Container quality={quality} radius={radius} className="quality-container">
      {quality}
    </Container>
  );
}

export default memo(Quality);
